import { render, staticRenderFns } from "./MandatoryTraining.vue?vue&type=template&id=07331a7e"
import script from "./MandatoryTraining.vue?vue&type=script&lang=js"
export * from "./MandatoryTraining.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports